<template>
	<Page>
		<div class="centered">

			<h1>Your templates &amp; configs</h1>

			<DashNav />

			<div class="home_actions">

				<div class="actions">
					<router-link :to="{name:'template.new'}" class="btn-a" >New template</router-link>
				</div>

				<div class="search_box">
					<div class="search_inner">
						<input type="text" v-model="search_string" placeholder="Search" ref="searchbox" />
						<i class="fa fa-search"></i>
					</div>
				</div>
			
			</div>


			<div v-if="orgs_loaded && templates_loaded && !templates.length" class="raised-box p-box-more "  >
				<div class="centered mw-narrow t-center">
					<h2>Create your first template</h2>
					<p>Templates allow you to generate config files using forms. The first step in generating configs is to create your first template.</p>
					<p><router-link :to="{name:'template.new'}" class="btn-a">Create a template now</router-link></p>
				</div>
			</div>
			<div v-else class="raised-box"  >
				<List
					:loading="!(orgs_loaded && templates_loaded)"
					:results="sorted_filtered_templates"
					:columns="[
						{
							label:'Name',
							name:'name',
							rowClick:true,
							to : (v,t)=>({name:'template',params:{'template_id':t.id}})
						},
						{
							label:'Organisation',
							name:'org',
							text : (v,t)=>{
								var org = orgs.find((o)=>o.id==t.org_id);
								return org ? org.name||'Personal' : '??';
							},
						},
						{
							label:'Updated',
							name:'updated_at',
							text : (v,t)=>{
								return dsplDate(v);
							},
						},
					]"
				/>
			</div>

		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page';
	import List from '../components/List';
	import DashNav from '../components/DashNav';


	export default {
		mixins : [Page],
		components : {List,DashNav},
		data() {
			return {
				search_string : '',
				orgs : [],
				templates : [],
				orgs_loaded : false,
				templates_loaded : false,
			};
		},
		mounted(){
			this.refreshList();
			this.$refs.searchbox.focus();
		},
		computed:{
			greeting(){
				var name = this.$store.state.auth.user.first_name;

				var options = [
					'Hi '+ name+'!',
					'Hello '+ name+'!',
				];

				var d = new Date;
				var h = d.getHours();
				if(h < 12){
					options.push('Goooood morning '+name+'!');
					options.push('Morning '+name+'!');
				} else if(h < 15){
					options.push('Afternoon '+name+'!');
					options.push('Good afternoon '+name+'!');
				} else if(h < 20){
					options.push('Evening '+name+'!');
					options.push('Good evening '+name+'!');
				} else {
					options.push('Someone is working late this evening!');
					options.push('Good evening '+name+'!');
				}

				return options[ Math.floor(options.length * Math.random()) ];
			},
			sorted_filtered_templates(){
				return this.filtered_templates.sort((a,b)=>{
					if(a.updated_at>b.updated_at) return -1;
					if(a.updated_at==b.updated_at) return 0;
					return 1;
				});
			},
			filtered_templates(){
				var self = this;
				var search_segments = self.search_string.toLowerCase().split(' ').filter(x=>x);
				if(!search_segments.length) return self.templates;
				
				return this.templates.filter((template)=>{
						
					var subject = [template.name].join(' ').toLowerCase();

					// Gauntlet style
					// Accumulator has to stay true throughout. Any failure along the way
					// turns it false 
					return search_segments.reduce((a,c)=>{
						if(!a) return a;
						return subject.includes(c);
					},true);
				});			
			}
		},
		methods:{
			refreshList(){
				var self = this;

				api.list('template',{},{sync_list:self.templates})
					.then((users)=>{ self.templates_loaded = true })

				self.$store.dispatch('auth/refreshOrgs').then(function(orgs){
					self.orgs = orgs;
					self.orgs_loaded = true;
				});
			},
			dsplDate(mysql_string){
				var d = moment.utc(mysql_string);
				var since = moment.duration(moment().diff(d));
				var hours_since = since.asHours();
				if(hours_since < 24){
					return d.fromNow();
				} else {
					return d.format('DD/MM/YY');
				}
			}
			
			
		}
	}

</script>